import React from 'react'
import { Row, Col, Form, Button, Image } from 'react-bootstrap'
import { SubHeader, Input } from '../../../components'
import scbLogo from '../../../../../resources/images/merchant-logo-grey.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { regEx } from '../../../../../resources/Utils';
const GeneralProfile = ({ disabled, onLogoChange, onLogoDelete, action, ...props }) => {

  const businessTypeOptions = <option key={props["businessType"]} value={props["businessType"]}>{props["businessTypeName"]}</option>; 

  return (
    <>
      <SubHeader text="Merchant General Profile" />
      <Row className="mt-3">
        <Col>
          <Input text="Merchant Tax ID" placeholder="merchant Tax ID" required name="taxId" value={props["taxId"]} format="NUMERIC" maxLength={13} disabled={action !== 'create'}/>
        </Col>
        <Col>
          <Form.Label className="text-grey font-weight-bold medium required">{"Business Type"}</Form.Label>
          <Form.Control 
            as="select" 
            name="businessType" 
            value={props["businessType"]} 
            disabled={disabled}
            required>
              <option value="" hidden>Select</option>
              {businessTypeOptions}
          </Form.Control>
        </Col>
      </Row>
      <Row>
        <Col>
          <Input text="Merchant Trading Name"
            placeholder="merchant trading name" 
            required
            name="tradingName" 
            value={props["tradingName"]} 
            disabled={disabled} 
            pattern={regEx.ALPHANUMERIC}
            maxLength={255}
            title="Merchant trading name must be alphanumeric"
          />
        </Col>
        <Col>
          <Input text="Merchant Name" 
            placeholder="merchant name" 
            required 
            name="merchantName" 
            value={props["merchantName"]}  
            disabled={disabled}
            pattern={regEx.ALPHANUMERIC}
            maxLength={128}
            title="Merchant name must be alphanumeric"
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Input text="Merchant Corporate ID" 
            placeholder="merchant corporate id"
            name="merchantCorpId" 
            value={props["merchantCorpId"]}  
            disabled
            title="Merchant Corporate ID must be alphanumeric"
          />
        </Col>
      </Row>
      <Row className="mt-1">
        <Col>
          <Form.Label className="text-grey font-weight-bold medium">{"Merchant Logo"}</Form.Label>
          <div>
            <Image className="h-100 w-100 img-thumbnail" src={props["merchantLogo"] ? props["merchantLogo"] : scbLogo}/>
          </div>
        </Col>
        <Col className="mt-4">
          <Row>
            <Col>
              <Form.Label className="text-grey font-weight-bold medium">{"Merchant Logo Requirement:"}</Form.Label>
              <ul className="mb-5 text-grey medium">
                <li>Must be in square size</li>
                <li>Must be in format of PNG or JPG</li>
                <li>Must not exceed 300KB</li>
              </ul>
            </Col>
          </Row>
          <Row className="ml-1 mr-3">
            <Col sm={11} className="custom-file px-1">
              <Form.Label className="custom-file-label">{props["merchantLogoFileName"] !== "" ? props["merchantLogoFileName"] : "Choose file to upload"}</Form.Label>
              <Form.Control 
                  className="custom-file-input"
                  type="file"
                  name="merchantLogo"
                  accept={[".png", ".jpg"]}
                  onChange={onLogoChange}
                  disabled={action==="view"}
                  value=""
              />
              <Form.Text className="text-danger ">{props["merchantLogoErrorMessage"]}</Form.Text>
            </Col>
            <Col sm={1} className="pl-0">
              <Button variant="link" className="link" onClick={onLogoDelete} disabled={action==="view"}>
                <FontAwesomeIcon size="lg" icon={faTrashAlt}/>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default GeneralProfile
